import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'labelFunction'})
export class LabelFunctionPipe implements PipeTransform {
    
    transform(value: any, column: any): any {
        return column.labelFunction(column, value);
    }
}